module.exports = __webpack_public_path__ + "static/media/wtResourceImg.2576a821.png";